
import React from 'react'

// eslint-disable-next-line react/prop-types
const DownloadSVG = ({className, style, fill ="#fff"}) => (

  <svg style={style} className={className} width="16" height="16" viewBox="0 0 20 17" xmlns="http://www.w3.org/2000/svg">
<path d="M10.0001 0C9.44783 0 9.00012 0.447715 9.00012 1V8.82854L6.46458 6.29301C6.07406 5.90248 5.44089 5.90248 5.05037 6.29301C4.65984 6.68353 4.65984 7.3167 5.05037 7.70722L9.29301 11.9499C9.68353 12.3404 10.3167 12.3404 10.7072 11.9499L14.9499 7.70722C15.3404 7.3167 15.3404 6.68353 14.9499 6.29301C14.5593 5.90248 13.9262 5.90248 13.5356 6.29301L11.0001 8.82854V1C11.0001 0.447715 10.5524 0 10.0001 0ZM0 6C0 5.44771 0.447715 5 1 5C1.55228 5 2 5.44772 2 6V15H18V6C18 5.44771 18.4477 5 19 5C19.5523 5 20 5.44772 20 6V16C20 16.5523 19.5523 17 19 17H1C0.447715 17 0 16.5523 0 16V6Z" fill={fill}/>
</svg>


  )

  export default DownloadSVG
